// Direction artistique pastel de l'espace pédagogique (septembre 2026),
// reprise des pages accélérateurs : fonds lavande, taches floues, cartes
// blanches translucides, dégradés doux, étiquettes violettes en chasse fixe,
// un seul accent orange. Chaque classe a sa variante sombre.

export const PASTEL_CARD =
    "rounded-3xl bg-white/80 ring-1 ring-slate-900/5 backdrop-blur dark:bg-bgDark-800/80 dark:ring-white/10";

export const PASTEL_SOLID_CARD =
    "rounded-3xl bg-white ring-1 ring-slate-900/5 dark:bg-bgDark-800 dark:ring-white/10";

export const PASTEL_GRADIENT_CARD =
    "relative overflow-hidden rounded-3xl bg-gradient-to-br from-[#EAF1FF] via-[#F1ECFF] to-[#FFEFE6] ring-1 ring-slate-900/5 dark:from-[#1B2340] dark:via-[#211C3D] dark:to-[#2A1F25] dark:ring-white/10";

export const PASTEL_WARM_CARD =
    "relative overflow-hidden rounded-3xl bg-gradient-to-br from-[#FFF1E6] via-[#FFF8F1] to-[#F1ECFF] ring-1 ring-[#E8511D]/20 dark:from-[#2B1E18] dark:via-[#1E1B2E] dark:to-[#211C3D] dark:ring-[#E8511D]/30";

export const PASTEL_VIOLET_CARD =
    "relative overflow-hidden rounded-3xl bg-gradient-to-br from-[#E9E2FF] via-[#EEF2FF] to-[#FFF1E6] ring-1 ring-[#613BDB]/20 dark:from-[#241D46] dark:via-[#1B2340] dark:to-[#2A1F25] dark:ring-[#613BDB]/30";

export const PASTEL_LABEL =
    "mb-0 font-geistMono text-[11px] uppercase tracking-[0.16em] text-[#613BDB] dark:text-[#B9A6FF]";

export const PASTEL_MUTED_LABEL =
    "mb-0 font-geistMono text-[11px] uppercase tracking-[0.16em] text-slate-400 dark:text-grayDark-500";

export const PASTEL_GHOST_BUTTON =
    "inline-flex items-center gap-1.5 rounded-xl bg-white/80 px-3.5 py-2 text-sm font-medium text-slate-700 ring-1 ring-slate-900/5 transition-colors hover:bg-white disabled:opacity-50 dark:bg-bgDark-700/80 dark:text-grayDark-100 dark:ring-white/10 dark:hover:bg-bgDark-700";

export const PASTEL_VIOLET_BUTTON =
    "inline-flex items-center gap-1.5 rounded-xl bg-[#613BDB] px-3.5 py-2 text-sm font-medium text-white shadow-[0_12px_30px_-12px_rgba(97,59,219,0.6)] transition-colors hover:bg-[#5431C4] disabled:opacity-50";

export const PASTEL_SOFT_VIOLET_BUTTON =
    "inline-flex items-center gap-1.5 rounded-xl bg-[#F6F3FF] px-3.5 py-2 text-sm font-medium text-[#613BDB] ring-1 ring-[#613BDB]/20 transition-colors hover:bg-[#EFE9FF] disabled:opacity-50 dark:bg-[#613BDB]/15 dark:text-[#C9BBFF] dark:ring-[#613BDB]/30";

/** Taches floues du fond, à poser dans un conteneur relative overflow-hidden. */
export function PastelBlobs() {
    return (
        <div aria-hidden className="pointer-events-none absolute inset-0 overflow-hidden">
            <div className="absolute -left-24 -top-32 h-[420px] w-[420px] rounded-full bg-[#E4DCFF] opacity-80 blur-3xl dark:bg-[#613BDB]/20" />
            <div className="absolute -top-20 right-0 h-[360px] w-[360px] rounded-full bg-[#D8ECFF] opacity-80 blur-3xl dark:bg-sky-500/10" />
            <div className="absolute left-1/2 top-24 h-[280px] w-[280px] rounded-full bg-[#FFE6D9] opacity-70 blur-3xl dark:bg-[#E8511D]/10" />
        </div>
    );
}

/**
 * En-tête d'un onglet de la fiche apprenant, sur le modèle de celui du
 * suivi : étiquette, titre, phrase d'appui, actions à droite. Tous les
 * onglets commencent ainsi au même endroit, boutons compris.
 */
export function PastelTabHeader({ label, title, description, actions }) {
    return (
        <div className="mb-6 flex flex-wrap items-center justify-between gap-3">
            <div className="min-w-0">
                <p className={PASTEL_LABEL}>{label}</p>
                <h2 className="mb-0 mt-1 font-geistSans text-2xl font-bold tracking-tight text-slate-900 dark:text-white">
                    {title}
                </h2>
                {description && (
                    <p className="mb-0 mt-1 max-w-2xl text-sm text-slate-500 dark:text-grayDark-400">{description}</p>
                )}
            </div>
            {actions && <div className="flex flex-wrap gap-2">{actions}</div>}
        </div>
    );
}
